import script from "./ChangePasswordView.vue?vue&type=script&setup=true&lang=js"
export * from "./ChangePasswordView.vue?vue&type=script&setup=true&lang=js"

import "./ChangePasswordView.vue?vue&type=style&index=0&id=74adfb6c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74adfb6c"]])

export default __exports__